import { render, staticRenderFns } from "./posDetail.vue?vue&type=template&id=44ac6646&scoped=true&"
import script from "./posDetail.vue?vue&type=script&lang=js&"
export * from "./posDetail.vue?vue&type=script&lang=js&"
import style0 from "./posDetail.vue?vue&type=style&index=0&id=44ac6646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ac6646",
  null
  
)

export default component.exports